import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'katex/dist/katex.min.css'; // KaTeX CSS 스타일 적용
import App from './App';

// Q-net API 테스트 스크립트 로드 (개발 환경에서만)
if (process.env.NODE_ENV === 'development') {
  // 페이지 로드 후 잠깐 기다린 후 로드
  setTimeout(() => {
    import('./utils/qnetApiTest.js').then((module) => {
      console.log('🔧 Q-net API 테스트 도구가 로드되었습니다.');
      console.log('📋 브라우저 콘솔에서 window.qnetApiTest를 사용하세요.');
      
      // 모듈을 전역으로 명시적으로 설정
      if (typeof window !== 'undefined') {
        window.qnetApiTest = {
          testBasic: module.testBasicConnection,
          testSingle: module.testSingleJob,
          testAll: module.testAllJobCodes,
          config: module.QNET_API_CONFIG,
          callAPI: module.callQnetAPI
        };
        console.log('✅ window.qnetApiTest 설정 완료');
      }
    }).catch(error => {
      console.error('❌ Q-net API 테스트 도구 로드 실패:', error);
    });
  }, 1000);
}

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 크롤러용 정적 셸(data-static-shell)이면 비우고 렌더, react-snap 프리렌더면 hydrate, 그 외 일반 렌더
const isStaticShell = rootElement.firstElementChild?.hasAttribute('data-static-shell');
if (rootElement.hasChildNodes() && !isStaticShell) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  if (isStaticShell) rootElement.innerHTML = '';
  ReactDOM.createRoot(rootElement).render(app);
}

// Service Worker 등록
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
        
        // 업데이트 체크
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // 새 버전 사용 가능 알림
                console.log('새 버전이 사용 가능합니다. 새로고침하세요.');
                
                // 사용자에게 알림 (선택사항)
                if (window.confirm('새 버전이 사용 가능합니다. 지금 업데이트하시겠습니까?')) {
                  window.location.reload();
                }
              } else {
                console.log('콘텐츠가 오프라인 사용을 위해 캐시되었습니다.');
              }
            }
          });
        });
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// PWA 설치 프롬프트
let deferredPrompt;

window.addEventListener('beforeinstallprompt', (e) => {
  console.log('PWA 설치 프롬프트 준비됨');
  // 기본 설치 프롬프트 방지
  e.preventDefault();
  // 나중에 사용하기 위해 이벤트 저장
  deferredPrompt = e;
  
  // 설치 안내 메시지 표시 (선택사항)
  console.log('앱을 홈 화면에 추가할 수 있습니다!');
});

// 설치 완료 후 처리
window.addEventListener('appinstalled', (evt) => {
  console.log('PWA가 성공적으로 설치되었습니다!');
  deferredPrompt = null;
});